import { Switch } from '@headlessui/react';
import { FC, useState } from 'react';
import { saveObjection } from '@/app/api';
import { updateClaimObjection } from '@/store/slices/claimsSlice';
import { useAppDispatch } from '@/store/store';

interface ISwitchCell {
  id: number;
  objection: boolean;
  disabled: boolean;
}

export const SwitchCell: FC<ISwitchCell> = ({ id, objection, disabled }) => {
  const [enabled, setEnabled] = useState(objection);

  const dispatch = useAppDispatch();

  const handleChangeSwitch = (status: boolean) => {
    setEnabled(status);

    dispatch(updateClaimObjection({ id, status }));

    saveObjection(id, status);
  };

  return (
    <div className="flex items-center gap-x-3">
      <span
        className={`text-base font-jostRegular font-normal ${
          !enabled ? 'text-gray-900' : 'text-gray-500'
        } ${disabled ? 'text-gray-400' : ''}`}>
        Ingen
      </span>
      <Switch
        checked={enabled}
        onChange={(val) => handleChangeSwitch(val)}
        className={`relative inline-flex w-[32px] h-[8px] items-center rounded-full transition-colors cursor-pointer 
          ${disabled ? 'bg-gray-300 !cursor-not-allowed' : 'bg-[#8CA2CE]'}
        `}
        disabled={disabled}>
        <span
          className={`${enabled ? 'translate-x-6' : '-translate-x-1'}
            inline-block w-[13px] h-[13px] transform rounded-full transition 
            ${disabled ? 'bg-gray-500' : 'bg-[#1F2B40]'}
          `}
        />
      </Switch>
      <span
        className={`text-base font-jostRegular font-normal ${
          enabled ? 'text-gray-900' : 'text-gray-500'
        } ${disabled ? 'text-gray-400' : ''}`}>
        Ja
      </span>
    </div>
  );
};
